import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../firebase/AuthContext';

function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  const location = useLocation();
  if (!currentUser) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }
  return children;
}

export default ProtectedRoute;
